import { useEffect } from "react";
import styled from "styled-components";
import SimpleModal from "~/components/SimpleModal";
import createForm from "~/shared/Form";
import TextareaInput from "~/shared/TextareaInput";
import SelectInput from "~/shared/SelectInput";
import Spinner from "~/shared/Spinner";
import yup from "~/utils/yup";
import { AnyRecord } from "~/types/record";
import CancelReasonInput from "../CancelReasonInput";
import CheckboxInput from "~/shared/CheckboxInput";
import useAuth from "~/hooks/useAuth";

const Container = styled.div`
    form > div:not(.action-section) {
        padding: 0 17px;
    }

    .action-section {
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        overflow: hidden;
    }

    .action-section button {
        width: 50%;
        padding: 10px;
        font-family: "Inter", sans-serif;
    }

    .action-section button.cancel-button {
        background-color: #dc3545;
        color: #fff;
    }

    .action-section button.cancel-button:disabled {
        background-color: #bb6b73;
    }
`;

const schema = yup.object().shape({
    reasonId: yup.string().required(),
    cancelObservation: yup.string().notRequired().nullable()
});

const [Field, Form] = createForm(
    {
        cancelObservation: {
            label: "Observação",
            component: TextareaInput,
            rows: 8
        },
        reasonId: {
            label: "Motivo do cancelamento",
            component: CancelReasonInput,
            placeholder: 'Selecione'
        },
        canSendRescheduleLink: {
            label: "Enviar link de reagendamento",
            component: CheckboxInput
        },

    },
    { validationSchema: schema }
);

type CancelJobModalProps = {
    show: boolean;
    closeFn: () => void;
    onCancel: (data: AnyRecord) => Promise<any>;
};

const CancelJobModal = ({ show, closeFn, onCancel }: CancelJobModalProps) => {
    const {user} = useAuth()
    useEffect(() => {
        if (show && window) {
            window.scrollTo(0, 0);
        }
    }, [show]);

    const onSubmit = async (data: AnyRecord) => {
        return onCancel(data);
    };

    return (
        <>
            {show ? (
                <>
                    <SimpleModal show={show} closeFn={closeFn} size="small">
                        <SimpleModal.Header>Deseja realmente cancelar esse job?</SimpleModal.Header>

                        <Container className="content">
                            <Form
                                onSubmit={onSubmit}
                                initialData={{canSendRescheduleLink: user?.id_organizacoes === 80 }}
                                renderButton={({ loading }) => (
                                    <>
                                        <button type="button" onClick={() => closeFn()}>Sair</button>
                                        <button type="submit" className="cancel-button" disabled={loading}>
                                            {loading ? <Spinner /> : "Cancelar"}
                                        </button>
                                    </>
                                )}
                            >
                                <Field name="reasonId" />
                                <Field name="canSendRescheduleLink" />
                                <Field name="cancelObservation" />
                            </Form>
                        </Container>
                    </SimpleModal>
                </>
            ) : ""}
        </>
    );
};

export default CancelJobModal;
